var Writaholics = Writaholics || {};

Writaholics.Navbar = function() {

	var _targetObservable = '.page-top';
  var _navbarWrapper = '.navbar-bg';
  var _navbarWrapperScrolled = 'topnav-wrapper--scrolled';
  var _navbarLinksWrapper = '#navbarLinks';

  var _isLeaving = false;

  var _init = function() {
    // cache the navbar and the links wrapper
    var navbar = $(_navbarWrapper);
    var navbarLinksWrapper = $(_navbarLinksWrapper);
    // only run if scrolled class not yet attached
    if (!navbar.hasClass(_navbarWrapperScrolled)) {
      // check intersection observer browser support
      if (
        "IntersectionObserver" in window &&
        "IntersectionObserverEntry" in window &&
        "intersectionRatio" in window.IntersectionObserverEntry.prototype
      ) {
        // continue with intersection observer
        var observable = document.querySelector(_targetObservable);
        var observableConfig = {
          root: null,
          threshold: 1
        };
        var observer = new IntersectionObserver(_onObserve, observableConfig);
        observer.observe(observable);
      } else {
        jQuery(_navbarWrapper).addClass(_navbarWrapperScrolled);
      }
      _collapseHandler(navbarLinksWrapper, navbar);
      _clickHandler(navbarLinksWrapper);
    }
  }

  var _onObserve = function(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        _isLeaving = true;
        jQuery(_navbarWrapper).removeClass(_navbarWrapperScrolled);
      } else if (_isLeaving || entry.intersectionRatio === 0) {
        _isLeaving = false;
        jQuery(_navbarWrapper).addClass(_navbarWrapperScrolled);
      }
    });
  }

  var _collapseHandler = function(navbarLinksWrapper, navbar) {
    navbarLinksWrapper.on('show.bs.collapse', function () {
      if (!navbar.hasClass(_navbarWrapperScrolled)) {
        navbar.addClass(_navbarWrapperScrolled);
      }
    })
    navbarLinksWrapper.on('hidden.bs.collapse', function () {
      if (navbar.hasClass(_navbarWrapperScrolled)) {
        navbar.removeClass(_navbarWrapperScrolled);
      }
    });
  }

  var _clickHandler = function(navbarLinksWrapper) {
    navbarLinksWrapper.find('a').on('click', function () {
      if (navbarLinksWrapper.hasClass('show')) {
        navbarLinksWrapper.collapse('hide');
      }
    })
  }

  /** PUBLIC API **/
  return {
    init : function() {return _init();}
  };

}();

jQuery(function() {
  Writaholics.Navbar.init();
});
